import { CHANGELOG, formatChangelogDate, type ChangelogEntry } from './changelog';

/** A lista de novidades, datada, em linguagem simples (I5). Texto é texto: sem HTML. */
export function ChangelogList({ entries = CHANGELOG }: { entries?: readonly ChangelogEntry[] }) {
  return (
    <ol className="flex flex-col gap-6">
      {entries.map((entry) => (
        <li key={entry.id} className="flex flex-col gap-2">
          <p className="text-2xs uppercase text-subtle-foreground">
            <time dateTime={entry.date}>{formatChangelogDate(entry.date)}</time>
          </p>
          <h3 className="text-md text-foreground">{entry.title}</h3>
          <ul className="flex list-disc flex-col gap-1 pl-5 text-sm text-muted-foreground">
            {entry.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  );
}
